import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_FULL_USER_REVIEWS } from "@/graphql/queries/user";
import { Spinner } from "@aqar-app/react-ui";
import css from "@/components/login-alert/loginAlert.module.scss";
import RatingStars, { OutlineStar } from "@/components/rateBooking/RatingStars";
import InfiniteScroll from "react-infinite-scroll-component";

const UserReviewsList = ({ userId }) => {
  const [reviews, setReviews] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const BATCH_SIZE = 10;

  const { loading, data, fetchMore } = useQuery(GET_FULL_USER_REVIEWS, {
    variables: { user_id: userId, offset: 0 },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data?.User?.reviews?.reviews) {
      setReviews(data.User.reviews.reviews);
      if (
        data.User.reviews.reviews.length < BATCH_SIZE ||
        data.User.reviews.reviews.length >= data.User.reviews.total
      ) {
        setHasMore(false);
      }
    }
  }, [data]);

  const loadMoreReviews = () => {
    fetchMore({
      variables: {
        offset: reviews.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        const newReviews = fetchMoreResult.User.reviews.reviews;

        if (
          newReviews.length < BATCH_SIZE ||
          reviews.length + newReviews.length >=
            fetchMoreResult.User.reviews.total
        ) {
          setHasMore(false);
        }

        return {
          User: {
            ...prev.User,
            reviews: {
              ...prev.User.reviews,
              reviews: [...prev.User.reviews.reviews, ...newReviews],
            },
          },
        };
      },
    });
  };

  if (loading && reviews.length === 0) {
    return (
      <div className={css.infiniteScrollContainer}>
        <div
          className={css.reviewsList}
          style={{
            minHeight: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner size="medium" />
        </div>
      </div>
    );
  }

  return (
    <div className={css.infiniteScrollContainer}>
      <InfiniteScroll
        dataLength={reviews.length}
        next={loadMoreReviews}
        hasMore={hasMore}
        loader={
          <div style={{ textAlign: "center", padding: "10px" }}>
            <Spinner size="small" />
          </div>
        }
        scrollableTarget="reviewsScrollContainer"
        className={css.reviewsList}
        id="reviewsScrollContainer"
        style={{ maxHeight: "300px", overflow: "auto", width: "100%" }}
      >
        {reviews.map((review) => (
          <div className={css.reviewItem} key={review.review_id}>
            <div className={css.reviewText}>{review.content}</div>
            <div className={css.reviewRating}>
              <RatingStars
                value={review.value}
                hideLabel={true}
                isStatic
                starComponent={OutlineStar}
              />
            </div>
          </div>
        ))}
        {reviews.length === 0 && (
          <div style={{ padding: "20px", textAlign: "center" }}>
            لا توجد تقييمات
          </div>
        )}
      </InfiniteScroll>
    </div>
  );
};

export default UserReviewsList;
